import constants from '@/constants';
import { isDebugOn } from '@/logger';

export default {
  props: {
    autoClose: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: constants.DEFAULT_SMALL_POPUP_TIMEOUT,
    },
    closeButton: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      required: false,
      default: 'top',
    },
    padding: {
      type: Boolean,
      default: true,
    },
    overlay: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    classModifier() {
      return {
        [`modal-small--${this.type}`]: this.type,
        'modal-small--no-padding': !this.padding,
      };
    },
  },
  mounted() {
    if (this.autoClose && !isDebugOn()) {
      setTimeout(() => this.close(), this.closeTimeout);
    }
  },
  methods: {
    close() {
      this.$emit('modalClose');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/modal/small/small.js